export default __webpack_public_path__ + "static/media/format-image-test.47d276ce.jpg";